interface Contributors {
  name: string;
  role?: string;
}

// Record containing contributors each year. Follow pattern under if you are adding new contributors.
export const contributors: Record<string, Contributors[]> = {
  "2021/2022": [
    { name: "Kristoffer Grude" },
    { name: "Benedikte Bitnes" },
    { name: "Tord Espe" },
    { name: "Wilhelm Medhus" },
    { name: "Aina Lie" },
    { name: "Frederick Pretlove" },
    { name: "Håkon Sønstebø" },
    { name: "Liv Semlitsch" },
  ],
  "2022/2023": [
    { name: "Frederick Pretlove" },
    { name: "Aina Lie" },
    { name: "Håkon Sønstebø" },
    { name: "Liv Semlitsch" },
    { name: "Emilie Lysaker Høgne" },
    { name: "Herman Bergheim" },
    { name: "Karoline Torø" },
    { name: "Ola Hagerupsen Hansen" },
    { name: "Simen Birkeland" },
  ],
  "2023/2024": [
    { name: "Herman Bergheim" },
    { name: "Emilie Lysaker Høgne" },
    { name: "Karoline Torø" },
    { name: "Ola Hagerupsen Hansen" },
    { name: "Simen Birkeland" },
    { name: "Helene Hoel Jomaas" },
    { name: "Peter Mikalsen" },
  ],
};
